const Table = {
  variants: {
    user: {
      table: {
        borderCollapse: 'separate',
        borderSpacing: '0',
      },
      thead: {
        th: {
          bg: 'neutral.50',
          color: 'neutral.500',
          fontSize: 'xs',
          fontWeight: '600',
          letterSpacing: '0.02em',
          textTransform: 'none',
          borderBottom: '1px solid',
          borderColor: 'neutral.200',
          py: 3,
        },
      },
      tbody: {
        tr: {
          transition: 'background 0.15s ease',
          _hover: {
            bg: 'neutral.50',
          },
        },
        td: {
          borderBottom: '1px solid',
          borderColor: 'neutral.100',
          py: 3,
          fontSize: 'sm',
          color: 'neutral.700',
        },
      },
    },
    admin: {
      thead: {
        th: {
          bg: 'neutral.100',
          color: 'neutral.600',
          fontSize: 'xs',
          fontWeight: '600',
          letterSpacing: '0.03em',
          textTransform: 'none',
          borderBottom: '2px solid',
          borderColor: 'neutral.200',
          py: 3,
        },
      },
      tbody: {
        tr: {
          transition: 'background 0.15s ease',
          _hover: {
            bg: 'brand.50',
          },
        },
        td: {
          borderBottom: '1px solid',
          borderColor: 'neutral.100',
          py: 2.5,
          fontSize: 'sm',
          color: 'neutral.700',
        },
      },
    },
  },
};

export default Table;
